import React from 'react';
import PropTypes from 'prop-types';
import { Box, List, ListItem, Link, HStack, Badge, Text, VStack, Icon, Heading, Tooltip } from '@chakra-ui/react';
import { ArrowSquareOut, Globe, Book } from '@phosphor-icons/react';
import { processCitations } from '../../utils/citationUtils';

const CitationList = ({ citations }) => { // Removed default [] here, will be handled by defaultProps
  const list = processCitations(citations);
  if (!list.length) return null;
  return (
    <Box p={4} borderWidth="1px" borderRadius="md">
      <VStack align="stretch" spacing={3}>
        <HStack><Heading as="h4" size="sm">Sources</Heading></HStack>
        <List spacing={3}>
          {list.map((c,i)=>(
            <ListItem key={c.id} id={c.id} fontSize="sm">
              <HStack align="baseline" spacing={2}>
                <Link href={c.url} isExternal fontWeight="bold" rel="noopener noreferrer">[{i+1}]</Link>
                <Badge px={2} borderRadius="full" bg={c.type==='book'?'orange.200':'blue.200'}>
                  <HStack spacing={1}><Icon as={c.type==='book'?Book:Globe} boxSize="0.8em"/><Text fontSize="xs">{c.type==='book'?'Book':'Web'}</Text></HStack>
                </Badge>
              </HStack>
              <Box ml={8}>
                {c.type==='book'? (
                  <Tooltip label="Search book on Google Books">
                    <Link href={c.url} isExternal rel="noopener noreferrer">{c.title} <Icon as={ArrowSquareOut} boxSize="0.8em"/></Link>
                  </Tooltip>
                ) : (
                  <Link href={c.url} isExternal rel="noopener noreferrer">{c.title} <Icon as={ArrowSquareOut} boxSize="0.8em"/></Link>
                )}
              </Box>
            </ListItem>
          ))}
        </List>
      </VStack>
    </Box>
  );
};

CitationList.propTypes = {
  citations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string, // Made URL optional as per test [CL-T4]
    // Add other expected properties if known and required
  })),
};

// Default props are handled by the default parameter in the function signature (line 7)
// CitationList.defaultProps = {
//   citations: [],
// };

export default CitationList;
